import AmexGDAChef from './AmexGDAChef';

export default AmexGDAChef;
